import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  InputBase,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputStylefield from "../../assets/InputStylefield";
import Select from "react-select";
import JoditEditor from "jodit-react";
import { useRef } from "react";
import UserLayout from "../../assets/UserLayout";
import Layout from "../../assets/Layout";
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useNavigate, useParams } from "react-router-dom";
import DeactivationDialog from "../ServiceDialogs/DeactivationDialog";
import { useDispatch, useSelector } from "react-redux";
import { getServiceById, updateServiceById } from "../../actions/userAuth";
import { enqueueSnackbar } from "notistack";






const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2544EE' : '#2544EE',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));






export default function EditServices() {
  const dispatch = useDispatch()

  const [service, setService] = useState("");
  const [deactivateService, setDeactivateService] = useState(false);

  const [serviceName, setServiceName] = useState('')
  const [trainingName, setTrainingName] = useState('')
  const [medium, setMedium] = useState([])
  const [language, setLanguage] = useState([])
  const [numberOfSessions, setNumberOfSessions] = useState('')
  const [durationPerSession, setDurationPerSession] = useState('')
  const [totalDuration, setTotalDuration] = useState('')
  const [descriptionByCoach, setDescriptionByCoach] = useState('')
  const [keyFeatures, setKeyFeatures] = useState('')
  const [currency, setCurrency] = useState('')
  const [suggestedPrice, setSuggestedPrice] = useState('')
  const [enterPrice, setEnterPrice] = useState('')
  const [earnedPrice, setEarnedPrice] = useState('')
  const [serviceStartedOn, setServiceStartedOn] = useState('')
  const [serviceLastEditedOn, setServiceLastEditedOn] = useState('')
  const [description, setDescription] = useState('')
  const [loading, setLoading] = useState(false);
  const [serviceStatus, setServiceStatus] = useState("");
  // const { user } = useSelector((state) => ({ ...state }));
  const { id } = useParams();

  const editor = useRef(null);

  const colourOptions = [
    { value: "Call", label: "Call" },
    { value: "Video Call", label: "Video Call" },
    { value: "Sms", label: "Sms" },
  ];

  const colourOptions1 = [
    { value: "Hindi", label: "Hindi" },
    { value: "English", label: "English" },
    { value: "French", label: "French" },
  ];

  const navigate = useNavigate();

  const handleLanguageChange = (selectedOption) => {
    setLanguage(selectedOption);
  };

  const handleMediumChange = (selectedOption) => {
    setMedium(selectedOption);
  };

  useEffect(() => {
    dispatch(getServiceById({ id }, (data) => {
      console.log(data.data.data);
      const serviceData = data.data.data;
      setServiceName(serviceData.serviceName);
      setTrainingName(serviceData.trainingName);
      setMedium(serviceData.medium);
      setLanguage(serviceData.language);
      setNumberOfSessions(serviceData.numberOfSessions);
      setDurationPerSession(serviceData.durationPerSession);
      setTotalDuration(serviceData.totalDuration);
      setDescriptionByCoach(serviceData.descriptionByCoach);
      setKeyFeatures(serviceData.keyFeatures);
      setCurrency(serviceData.currency);
      setSuggestedPrice(serviceData.suggestedPrice);
      setEnterPrice(serviceData.enterPrice);
      setEarnedPrice(serviceData.earnedPrice);
      setServiceStartedOn(serviceData.serviceStartedOn);
      setServiceLastEditedOn(serviceData.serviceLastEditedOn);
      setDescription(serviceData.descriptionByCoach);
      setDeactivateService(serviceData.deactivateService);
      setServiceStatus(serviceData.serviceStatus)
    }, (err) => {
      console.log(err);
    }));
  }, [dispatch, id]);

  const handleUpdate = () => {
    setLoading(true);
    // if (medium.length === 0 || language.length === 0 || !numberOfSessions || !durationPerSession || !totalDuration || !descriptionByCoach || !currency || !enterPrice) {
    //   enqueueSnackbar('Please fill in all required fields', { variant: 'warning' });
    //   return;
    // }

    const numberPattern = /^[0-9]*$/;
    if (!numberPattern.test(numberOfSessions)) {
      enqueueSnackbar('Number of session accepts only numbers', { variant: 'error' });
      setLoading(false);
      return;
    }
    // if (!numberPattern.test(durationPerSession) ) {
    //   enqueueSnackbar('Duration per session should be number only!', { variant: 'error' });
    //   return;
    // }
    if (!numberPattern.test(totalDuration)) {
      enqueueSnackbar('total duration should be number only!', { variant: 'error' });
      setLoading(false);
      return;
    }
    if (!numberPattern.test(enterPrice)) {
      enqueueSnackbar('price should be number only!', { variant: 'error' });
      setLoading(false);
      return;
    }
    if (!numberPattern.test(suggestedPrice)) {
      enqueueSnackbar('suggested Price should be number only!', { variant: 'error' });
      setLoading(false);
      return;
    }
    if (!numberPattern.test(earnedPrice)) {
      enqueueSnackbar('earned Price should be number only!', { variant: 'error' });
      setLoading(false);
      return;
    }
    console.log("medium = ", medium)
    console.log("language = ", language)
    console.log("no. of session = ", numberOfSessions)
    // Save data in local storage
    const payload = {
      serviceName,
      medium,
      language,
      numberOfSessions,
      durationPerSession,
      totalDuration,
      descriptionByCoach,
      keyFeatures,
      currency,
      suggestedPrice,
      enterPrice,
      earnedPrice,
      serviceStartedOn,
      serviceLastEditedOn,
    };

    // localStorage.setItem("serviceData", JSON.stringify(data));
    dispatch(
      updateServiceById(id, payload, (data) => {
        setLoading(false);
        enqueueSnackbar('Service Updated Successfully', { variant: 'success' });
        navigate("/coach/services-status");
      }, (err) => {
        setLoading(false);
        enqueueSnackbar("Error Occured! Please try again", { variant: 'warning' });
      })
    );

  };

  const handleCancle = () => {
    navigate("/coach/services-status");
  }




  return (
    <>
      <Layout>
        <UserLayout userRole={'coach'}>

        <Box sx={{ display: 'flex', flexDirection:{md:'row', xs:'column'}, mt: 8, borderRadius: '10px' }}>
                        <Typography className="heading2bold"> Services Status</Typography>
                        <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', }}>
                            <TextField
                                sx={{ marginLeft: '1rem'}}
                                className='profile-skills-box text2Light'
                                variant="outlined"
                                size="small"
                                placeholder="Search"                 
                                InputProps={{
                                    endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                }}
                            />
                        </Grid>
                    </Box>


     
         
         
          <Paper sx={{ my: 5 }}>
            <Box px={5} py={5} >
              <Box sx={{ display: 'flex',flexDirection: {md: 'row', xs:'column'}, justifyContent: 'space-between' }}>
                <Typography className="heading2bold">
                  Edit Services
                </Typography>
                <Box sx={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                  <Typography sx={{
                    fontFamily: "Inter",
                    fontSize:{md:'22px', xs:'18px'},
                    fontWeight: 700,
                    lineHeight: "32px",
                  }}>Deactivate the Service</Typography>
                  <FormControlLabel control={<IOSSwitch sx={{ m: 1 }} checked={!deactivateService} onChange={(e) => setDeactivateService(!e.target.checked)} />} /></Box></Box>
              <Divider
                sx={{
                  backgroundColor: "#d2d2d2",
                  height: "1px",
                  borderRadius: "2px",
                  marginTop: "1rem",
                }}
              />
            </Box>
            <Box px={5} pb={5}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={serviceName == "Training" ? 6 : 12}>
                  <InputStylefield name="Service Name*" topSpace={true}>
                    <select
                      className="profile-skills-box"
                      type="text"
                      placeholder="Select"
                      list="Type"
                      value={serviceName}
                      onChange={(e) => setServiceName(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="FULL-TIME">Full Time</option>
                      <option value="PART-TIME">Part Time</option>
                      <option value="FREELANCE">Freelance</option>
                      <option value="Training">Training</option>
                    </select>
                  </InputStylefield>
                </Grid>
                {serviceName == "Training"
                  ?
                  <Grid item xs={12} md={6}>
                    <InputStylefield name="Training Name*" topSpace={true}>
                      <input type="text" placeholder="Enter Your Training Name" value={trainingName} onChange={(e) => setTrainingName(e.target.value)} />
                    </InputStylefield>
                  </Grid>
                  :
                  ""
                }
                <Grid item md={6} xs={12}>
                  <InputStylefield name="Medium*" topSpace={true} value={medium} onChange={(e) => setMedium(e.target.value)}>
                    <select
                      value={medium}
                      onChange={(e) => setMedium(e.target.value)}
                      className="profile-skills-box"
                    >
                      <option value="" disabled selected>Select Medium</option>
                      <option value="Video">Video</option>
                    </select>
                  </InputStylefield>
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputStylefield name="Language*" topSpace={true} >
                    <select
                      value={language}
                      onChange={(e) => setLanguage(e.target.value)}
                      className="profile-skills-box"
                    >
                      <option value="" disabled selected>Select Language</option>
                      <option value="Hindi">Hindi</option>
                      <option value="English">English</option>
                    </select>
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputStylefield name="No. of Session*" topSpace={true}>
                    <input
                      value={numberOfSessions}
                      onChange={(e) => setNumberOfSessions(e.target.value)}
                      type="text"
                      placeholder="Enter number of sessions"
                    />
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputStylefield name="Duration Per Session*" topSpace={true}>
                    <select
                      className="profile-skills-box"
                      type="text"
                      placeholder="Select"
                      list="Type"
                      value={durationPerSession}
                      onChange={(e) => setDurationPerSession(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="FULL-TIME">Full Time</option>
                      <option value="PART-TIME">Part Time</option>
                      <option value="FREELANCE">Freelance</option>
                    </select>
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputStylefield
                    name="Total Service Duration*"
                    topSpace={true}

                  >
                    <input placeholder="Enter total Duration" value={totalDuration}
                      onChange={(e) => setTotalDuration(e.target.value)} />
                  </InputStylefield>
                </Grid>
                {
                  serviceName == "Training"
                    ?
                    ""
                    :
                    <Grid item xs={12} md={12}>
                      <label className="text2Bold">Description from Admin*</label>
                      <JoditEditor ref={editor} onChange={(newContent) => setDescription(newContent)}
                        value={description} />
                    </Grid>
                }
                <Grid item xs={12} md={12}>
                  <label className="text2Bold">
                    Additional Description By Coach*
                  </label>
                  <JoditEditor ref={editor} value={descriptionByCoach}
                    onChange={(e) => setDescriptionByCoach(e)} />
                </Grid>


                <Grid item xs={12} md={12}>
                  <InputStylefield
                    name="Key Feature of the service"
                    topSpace={true}
                  >
                    <input type="text" placeholder="Additional Details" />
                  </InputStylefield>
                </Grid>

                <Grid item xs={12} md={6}>
                  <InputStylefield name="Currency*" topSpace={true}>
                    <select
                      value={currency}
                      className="profile-skills-box"
                      type="text"
                      placeholder="Select"
                      list="Type"
                      onChange={(e) => setCurrency(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="FULL-TIME">USD</option>
                      <option value="PART-TIME">INR</option>
                      <option value="FREELANCE">POUND</option>
                    </select>
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputStylefield name="Suggested Price" topSpace={true}>
                    <input type="text" placeholder="Backend" value={suggestedPrice} onChange={(e) => setSuggestedPrice(e.target.value)} />
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputStylefield name="Enter Price*" topSpace={true}>
                    <input type="text" placeholder="Enter Enter Price" value={enterPrice} onChange={(e) => setEnterPrice(e.target.value)} />
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputStylefield name="Earned Price" topSpace={true}>
                    <input type="text" placeholder="Backend" value={earnedPrice} onChange={(e) => setEarnedPrice(e.target.value)} />
                  </InputStylefield>
                </Grid>

                <Grid item xs={12} sm={6}>

                  <Button
                    sx={{

                      backgroundColor: "#2544EE",
                      borderRadius: "2rem",
                      color: "#fff",
                      border: "1px solid #2544EE",
                      "&:hover": {
                        color: "#2544EE",
                        backgroundColor: "#F7FAFF",
                      },
                      textTransform: "none",
                      px: 5,
                      width: "100%", // Set the width to 100% to occupy the available space
                      "@media (min-width: 600px)": {
                        width: "auto", // Reset width to auto on larger screens
                      },
                    }}
                    variant="contained"
                    onClick={handleUpdate}
                    disabled={loading}
                  >
                    {
                      loading
                        ?
                        <CircularProgress size={24} />
                        :
                        "Update"
                    }
                  </Button>
                  <Button
                    sx={{
                      borderRadius: "2rem",
                      color: "#2544EE",
                      border: "1px solid #2544EE",
                      "&:hover": {
                        color: "#2544EE",

                      },
                      textTransform: "none",
                      ml:{md:5, xs:0},
                      mt:{md:0, xs:2},
                      px: 5,
                      width: "100%", // Set the width to 100% to occupy the available space
                      "@media (min-width: 600px)": {
                        width: "auto", // Reset width to auto on larger screens
                      },
                    }}
                    variant="outlined"
                    onClick={handleCancle}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </UserLayout>
      </Layout>
      <DeactivationDialog
        addDeactivation={deactivateService}
        setAddDeactivation={setDeactivateService}
      />
    </>
  );
}

